__turbopack_context__.v({
  "block-container": "rankings-module-scss-module__1txR6a__block-container",
  "block-content": "rankings-module-scss-module__1txR6a__block-content",
  "block-header": "rankings-module-scss-module__1txR6a__block-header",
  "block-header-actions": "rankings-module-scss-module__1txR6a__block-header-actions",
  "divider": "rankings-module-scss-module__1txR6a__divider",
  "quote-card": "rankings-module-scss-module__1txR6a__quote-card",
  "quote-card-compact": "rankings-module-scss-module__1txR6a__quote-card-compact",
  "quote-card-header": "rankings-module-scss-module__1txR6a__quote-card-header",
  "quote-card-name": "rankings-module-scss-module__1txR6a__quote-card-name",
  "quote-card-position": "rankings-module-scss-module__1txR6a__quote-card-position",
  "quote-card-price": "rankings-module-scss-module__1txR6a__quote-card-price",
});
